export default "__VITE_ASSET__BCdozkRr__"